(function () {
'use strict';

angular.module('hyresgastApp').controller('OwnersListCtrl', OwnersListCtrl);

function OwnersListCtrl($scope, $document, $location, $filter, $timeout,
  RealEstate) {
  var vm = this;

  vm.tableColumns = [
    {
      title: 'Namn',
      column: 'name',
    },
    {
      title: 'Organisationsnummer',
      column: 'organizationNumber',
    }
  ];
  vm.tableFGetData = RealEstate.queryOwners;
  let getTableau = () => angular.element($document[0].querySelector("#tableau")).scope();

  vm.gotoOwner = owner => {
    $location.path('/search/properties').search({ owners: owner.name });
  };

  vm.getContextInfo = row => ({
    title: `Ägare ${row.name}`,
    link: '/search/properties?owners='+encodeURI(row.name),
  });

  vm.refreshList = () => {
    let filters = $location.search();
    $timeout(() => { getTableau().$broadcast('refresh', filters) }, 200);
  }
}
})();